import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/contracts/notes/initialState.notes.data';
import {
  fetchNotes as fetchNotesAPI,
  postNotes as postNotesAPI,
} from '../../../../apis/contractsAPI';
import { ACTIONS_NOTES } from '../../../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import { formatDateIntoEnUS, generateNumaricUniqueId } from '../../../../utils/common';  

// API Call Functions
export const getNotesAPI = createAsyncThunkWrapper(
  ACTIONS_NOTES.GET_NOTES,
  fetchNotesAPI
);

export const postNotesApi = createAsyncThunkWrapper(
  ACTIONS_NOTES.POST_NOTES,
  postNotesAPI
);

const notesSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    setContractAddNotes: (state, action) => {
      state.notesData[action.payload.name] = action.payload.value;
    },
    handleModalOpen: (state) => {
      state.isModalOpen = true;
    },
    handleModalClose: (state) => {
      state.isModalOpen = false;
    },
    handleAddNewNotes: (state) => {
      state.notesData.comment = '';
    },
    handleResetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      //notes Get
      .addCase(getNotesAPI.pending, (state) => {
        state.isLoadingNotesData = true;
        state.contractNotesData = [];
      })
      .addCase(getNotesAPI.fulfilled, (state, action) => {
        state.isLoadingNotesData = false;
        let result = action.payload;
        if (result?.length > 0) {
          state.contractNotesData = result?.map((note) => ({
            ...note,
            contractNoteId: generateNumaricUniqueId(),
          }));
        } else {
          state.contractNotesData = [];
        }
        state.isDataAdded = false;
      })
      .addCase(getNotesAPI.rejected, (state) => {
        state.isLoadingNotesData = false;
      })

      //notes Post
      .addCase(postNotesApi.pending, (state) => {
        state.isAddLoadingNote = true;
        state.isDataAdded = false;
        state.noteAdded = '';
      })
      .addCase(postNotesApi.fulfilled, (state, action) => {
        state.isAddLoadingNote = false;
        state.isDataAdded = true;
        state.isModalOpen = false;
        let result = action.payload;
        result.lastModeifiedTimestamp = formatDateIntoEnUS(result.lastModifiedTimestamp);
        state.contractNotesData = [result, ...state.contractNotesData];
      })
      .addCase(postNotesApi.rejected, (state) => {
        state.isAddLoadingNote = false;
        state.isDataAdded = false;
        state.noteAdded = '';
      });
  },
});

export const {
  setContractAddNotes,
  handleModalOpen,
  handleModalClose,
  handleAddNewNotes,
  handleAddNewNotesSave,
  handleResetState,
} = notesSlice.actions;

export default notesSlice.reducer;
